export default "__VITE_ASSET__HQBMoEqA__"